import { TextInput } from '../../text-input';
import styled from 'styled-components';
import { getSizeBy } from '../../../../src/styled/utils';
export const StyledTextInput = styled(TextInput) `
  * > span {
    margin-right: ${getSizeBy(0)};
    padding-right: ${getSizeBy(1)};
  }
`;
